import { useEffect, useContext } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { IconButton, Typography, Stack } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import MainCard from 'ui-component/cards/MainCard';
import { useTheme } from '@mui/material/styles';

import ContractsContext from 'contexts/ContractsContext';

export default function SignContract() {
    const { sessionid } = useParams();
    const navigate = useNavigate();
    const theme = useTheme();
    const { state } = useLocation();

    const { loadContracts } = useContext(ContractsContext);

    const cardHeaderTitleStyles = {
        ...theme.typography.h6,
        ...(theme.components?.MuiCardHeader?.styleOverrides?.title || {})
    };

    const onClose = () => navigate('/contracts', { state });

    useEffect(() => {
        const handleMessage = async (event) => {
            const type = event.data && event.data.type;
            const payload = event.data && event.data.payload;

            switch (type) {
                case 'session_view.document.completed': {
                    const contracts = await loadContracts();
                    if (contracts?.length) {
                        onClose();
                    } else {
                        navigate(state?.callbackUrl ?? '/', { state: { callbackUrl: state?.parentCallbackUrl } });
                    }
                    break;
                }
                case 'session_view.document.exception':
                    console.log(payload);
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [navigate]);

    return (
        <MainCard
            title={
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography paddingLeft={1} sx={cardHeaderTitleStyles}>
                        Sign Contract
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CancelIcon />
                    </IconButton>
                </Stack>
            }
            sx={{ minHeight: '900px', '& .MuiCardHeader-root': { padding: 2 } }}
        >
            <iframe
                src={`https://app.pandadoc.com/s/${sessionid}`}
                width="100%"
                title="Sign Contract"
                style={{ border: 'none', minHeight: '900px', height: '100%' }}
            />
        </MainCard>
    );
}
